<!-- eslint-disable vue/require-component-is -->
<template>
  <div class="diagram-tile">
    <div class="diagram-tile-content">
      <div class="flex-row" v-if="true">
        <ButtonComponent elementType="hover"
                          elementStatus="selected"
                          @click="this.requestReportData(true)"
                          iconUrl="/icons/system/arrow-counter-clockwise.svg"
                          iconSize="22"/>
        <LabelComponent v-if="this.cacheTime != null" :label_text="'Диаграмма сформирована: ' + String(this.cacheTime)" :is_no_accent="true"/>
      </div>
      <div class="diagram-tile-content-diagram" ref="root_tile">
        <SpinnerComponent v-if="this.isDiagramDataRequesting" style="width: 50px;" :width="5" />
        <LabelComponent v-if="this.dataRequestError != null" :label_text="this.dataRequestError" style="color: red;"/>
        <StaticDiagramWraper v-if="this.curDiagramData != null">
          <template v-slot="{ diagramWidth }">
            <HybridChart
                  v-if="this.curChart == 'HistogramChart' || this.curChart == 'GraphChart' || this.curChart == 'HybridChart'"
                  :maxChartWidth="diagramWidth"
                  :typeName="this.curDiagramData.type"
                  :rawSeries="this.curDiagramData.series"
                  :rawPoints="this.curDiagramData.points"
                  :rawValues="this.curDiagramData.values"
                  @seriesSelect="this.openPage"
          />
          <PieChart
                  v-if="this.curChart == 'PieChart'"
                  :maxChartWidth="diagramWidth"
                  :maxDiagramHeight="diagramWidth"
                  :typeName="this.curDiagramData.type"
                  :rawSeries="this.curDiagramData.series"
                  :rawPoints="this.curDiagramData.points"
                  :rawValues="this.curDiagramData.values"
                  @seriesSelect="this.openPage"
                />
          <GanttChart v-if="this.curChart == 'GanttChart'"
                      :maxChartWidth="diagramWidth"
                      :maxDiagramHeight="diagramWidth"
                      :typeName="this.curDiagramData.type"
                      :rawSeries="this.curDiagramData.series"
                      :rawPoints="this.curDiagramData.points"
                      :rawValues="this.curDiagramData.values"
                      @seriesSelect="'this.openPage'"
          />
          </template>
        </StaticDiagramWraper>
      </div>
      <div class="diagram-tile-content-header" @click="this.openPage" v-if="true">
        <div class="diagram-tile-content-header-caption base-gap-row">
          <div class="icon-wrapper">
            <IconComponent size=37 :url="this.draw_page.icon_url"/>
          </div>

          <LabelComponent label_type="h3"
                          :label_text="this.draw_page.name"/>

          <div class="icon-wrapper" style="display: flex;">
            <IconComponent size="22" url="/icons/system/arrow-left.svg" style="transform: rotate(-180deg);"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">

const DiagramTypesList = {
  'gantt': 'GanttChart',
  'Гистограмма горизонтальная': 'HistogramChart',
  'Гистограмма': 'HistogramChart',
  'Гистограмма объемная': 'HistogramChart',
  'Гистограмма горизонтальная объемная': 'HistogramChart',
  'Гистограмма с накоплением': 'HybridChart',
  'График': 'GraphChart',
  'График с областями': 'GraphChart',
  'Смешанный': 'HybridChart',
  // 'График с накоплением': 'GraphChart',
  // 'График по шагам': 'GraphChart',
  'Кольцевая': 'PieChart',
  'Кольцевая объемная': 'PieChart',
  'Круговая': 'PieChart',
  'Круговая объемная': 'PieChart',
};

import GanttChart from '@/units/charts/GanttChart.vue';
import SpinnerComponent from '@/units/logo/StdSpinner.vue';
import LabelComponent from '@/units/RichLabel.vue';
import PieChart from '@/units/charts/PieChart.vue';
// import HistogramChart from '@/units/charts/HistogramChart.vue';
// import GraphChart from '@/units/charts/GraphChart.vue';
import HybridChart from '@/units/charts/HybridChart.vue';
import IconComponent from '@/units/RichIcon.vue';
import ButtonComponent from '@/units/forms/RichButton.vue';

import buildReport from '@/assets/dataSources/reports/buildReport.js';

import StaticDiagramWraper from '@/reportsLayout/StaticDiagramWraper.vue';

export default {
  components: {
    SpinnerComponent,
    IconComponent,
    ButtonComponent,
    LabelComponent,
    PieChart,
    // HistogramChart,
    // GraphChart,
    HybridChart,
    StaticDiagramWraper,
    GanttChart,
  },
  emits: ['isWide'],
  props: ['draw_page'],
  data: ()=> ({
    dataRequestError: null,
    requestVersion: 0,
    isDiagramDataRequesting: false,
    curDiagramData: null,
    cacheTime: null,
  }),
  watch: {
    $route(to, from) {
      if (String.comparePaths(to.path, from.path)) {
        return;
      }

      this.isDiagramDataRequesting = false;
      this.requestReportData();
    },
  },
  mounted() {
    this.requestReportData();
  },
  computed: {
    curChart() {
      return DiagramTypesList[this.curDiagramData.type];
    },
  },
  methods: {
    openPage() {
      this.$router.push(this.draw_page.fullUrl);
    },
    requestReportData(resetCache=false) {
      if (this.isDiagramDataRequesting) return;

      this.dataRequestError = null;

      this.curDiagramData = null;
      this.isDiagramDataRequesting = true;

      this.requestVersion += 1;
      const requestReportFormVersion = this.requestVersion;

      const buildForm = {};

      if (resetCache) {
        buildForm['__force_update_preview_cache'] = true;
      }

      buildReport(this.draw_page.uid, buildForm, (result) => {
        if (requestReportFormVersion != this.requestVersion) return;

        this.isDiagramDataRequesting = false;

        if (result._error == true) {
          if (result.status == null) {
            this.dataRequestError = `${result.text} Нет подключения к интернету либо на сервере ведутся технические работы.`;
          } else {
            this.dataRequestError = `${result.text} Статус: ${result.status}`;
          }
          return;
        }

        if (result.diagrams != null) {
          if (result.diagram_error != null) {
            this.dataRequestError = 'Ошибка формирования диаграммы. ' + String(result.diagram_error);
            return;
          }

          if (result.diagrams.length < 1) {
            this.dataRequestError = 'Отчет не содержит диаграмм';
            return;
          }

          this.curDiagramData = result.diagrams[0];
        } else {
          this.curDiagramData = result;
        }
        this.$emit('isWide', false);
        if (this.curChart != 'PieChart') {
          this.$emit('isWide', true);
        }

        this.cacheTime = null;

        if (result.__cached__ != null) {
          this.cacheTime = new FixDate(result.__cached__).toLocaleString();
        } else {
          this.cacheTime = new FixDate().toLocaleString();
        }
      });
    },
  },
};


</script>

<style lang="less">
.flex-row {
  .flex(row, flex-start, center);
}

.diagram-tile{

  &-content{
    padding: @base-gap;
    transition: color 0.2s;
    text-decoration: none;

    width: 100%;
    height: 100%;
    flex-grow: 1;

    &-header {
      cursor: pointer;

      .flex(row, space-between, center);
      width: 100%;

      &-caption {
        overflow-wrap: anywhere;
        .flex(row, center, center);

        .icon-wrapper{
          min-width: 52px;
          max-width: 52px;
          min-height: 52px;
          max-height: 52px;
          .flex(row,  center, center);
          .set_icon_color(@green);

          // margin-right: 15px;
          @media (max-width: @mobile-width) {
            display: none;
          }
        }
      }

      &-controls {
        .flex(row, center, center);

        margin-left: 13px;

        & > * {
          margin-right: 25px;

          transform: rotate(-90deg);
        }

        & > *:last-child {
          margin-right: 0;
        }
      }
    }

    &-diagram {
      // margin-top: 9px;
      &-wrapper {
        max-width: 1px;
        .flex(row, start, start);
        overflow-x: visible;
        // position: absolute;
      }
    }
  }
}
</style>
